// services/createSignalRConnection.js
import * as signalR from "@microsoft/signalr";

const API_URLS = {
  server: process.env.REACT_APP_API_URL?.replace(/\/$/, ""),
  mobile: process.env.REACT_APP_API_MOVIL_URL?.replace(/\/$/, ""),
};

const createConnection = (token, type = "server") => {
  const baseUrl = API_URLS[type];

  if (!baseUrl) {
    throw new Error(`❌ No se encontró la URL para el tipo "${type}" en .env`);
  }

  return new signalR.HubConnectionBuilder()
    .withUrl(`${baseUrl}/hubs/alerts`, {
      accessTokenFactory: () => token,
      transport: signalR.HttpTransportType.WebSockets,
      withCredentials: true,
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Debug)
    .build();
};

export default createConnection;